var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5L10.0837 9.57159C10.3937 9.10029 11.0319 8.9785 11.4936 9.30253L12.4255 9.95647C12.8895 10.2821 13.5311 10.1573 13.8392 9.68156L15.0512 7.81039C15.4477 7.19821 16.3451 7.20279 16.7354 7.81899L18 9.81579",
    stroke: "#111111",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 3V16C4 16.5523 4.44772 17 5 17H18.6667",
    stroke: "#111111",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharticon);
export default __webpack_public_path__ + "static/media/charticon.c9412263c737a4518fcf81a662e87cae.svg";
export { ForwardRef as ReactComponent };